import { IJobHOCState } from "redux/_core/job/types";

export enum VDM_DASHBOARD_TABS {
	PORT_CALLS = "port-calls",
	BUNKER_ROBS = "bunker-robs",
	LUBE_OILS = "lube-oils",
	BUNKER_CONSUMPTION = "bunker-consumption",
	CHEMICAL_ROBS = "chemical-robs",
	WEATHER = "weather",
	INSPECTION = "inspection",
	SECURITY = "security",
	STOPPAGES = "stoppages",
	LNG_CONSUMPTION = "lng-consumption",
	PIC = "pic",
}

export interface IOption {
	label: string;
	value: string;
}

export interface IVDMVesselStatus {
	title: string;
	subTitle: string;
	metricsToShow: IOption[];
}

export interface IBunkerEthaneTableRow {
	tankType: string;
	capacity: number;
	cargo: number;
	fuelROB: number;
	volume: number;
	tempTop: number;
	tempMid: number;
	tempBottom: number;
	pressure: number;
	density: number;
	bunkerLoc: string;
	bunkerDate: string;
	status: string;
}

export interface IVDMBunkerData {
	hfo: IBunkerFuelTableRow[];
	lsmgo: IBunkerFuelTableRow[];
	ethane: IBunkerEthaneTableRow[];
}

export interface IVDMBunker {
	bunkerData?: IVDMBunkerData;
}

export interface IVDMConsumptionVoyageSummary {
	title: string;
	period: string;
	value: string;
	unit: string;
}

export interface IVDMConsumption {
	voyageSummary: IVDMConsumptionVoyageSummary[];
	fuelConsumptionBreakdown: IConsumptionFuelData;
	fuelConsumptionByEquipmentType: IConsumptionFuelData;
	fuelConsumptionDistanceCovered: any; //TODO: can be changed once graph data contract is finalized
	draftSpeedImpactOnFuelConsumption: any;
}

export interface ICNRRecord {
	createdAt: string;
	doc_status: string;
	intlDateLineRecord: boolean;
	selectedDate: string;
	standaloneForm?: Record<string, any>;
	timeline: Record<string, any>[];
	_id: string;
}

export interface IVDMDashboardStore extends IJobHOCState {
	isAlertsExpanded: boolean;
	vdmVesselStatus?: IVDMVesselStatus[];
	selectedVDMTab?: VDM_DASHBOARD_TABS;
	bunker?: IVDMBunker;
	consumption?: IVDMConsumption;
	smartAlerts?: IVDMAlert[];
	cnrForDateRange?: ICNRRecord[];
	selectedVDMDashboardDate: string;
	cnrIdForSelectedDate: string;
	dashboardContent: IVDMDashboardContent | null;
	picContent: IVDMPICContent["departments"] | null;
}

export interface IBunkerFuelTableRow {
	tankType: string;
	capacity: string;
	currentVolume: string;
	sulphur: string;
	lastBunkerLocation: string;
	lastBunkerDate: string;
	status: string;
	dateColor: string;
}

export interface IConsumptionFuelData {
	title: string;
	columns: string[];
	rows: Array<
		Record<
			string,
			| string
			| {
					value: string;
					status: {
						type: string;
						message: string;
					};
			  }
		>
	>;
}

export interface IVDMAlert {
	title: string;
	value: number;
	percentageChange: number;
	chartData: { value: number }[];
	change: "UPWARDS" | "DOWNWARDS";
	actionLink: string;
}

export interface IVesselStatusBaseCard {
	title: string;
	subTitle: string;
}

export interface ICardAlerts {
	highPriority: string[];
	lowPriority: string[];
	info: string[];
}

export interface ICard1Data extends IVesselStatusBaseCard {
	alerts: ICardAlerts;
	metricsToShow: IOption[];
}

export interface ICard2Data extends IVesselStatusBaseCard {
	metricsToShow: IOption[];
}

export interface IChartDataItem {
	name: string;
	value: number;
	color: string;
}

export interface ICard3Data extends IVesselStatusBaseCard {
	metricsToShow: IOption[];
	chartData: IChartDataItem[];
}

export interface IPIC {
	department: string;
	// status: string;
	// statusLabel: string;
	profilePicture?: string;
	name: string;
	email: string;
	contact: string;
}

export interface IOperationLogsReporting {
	lastReportedAt: string;
	reportedBy: string;
}

export interface IOperationLogsDetails {
	qty: number;
	boatName?: string | null;
}

export interface IOperationLogsActivity {
	id: string;
	activity: string;
	region: string;
	inTime: string;
	outTime: string;
	vendor: string;
	reporting: IOperationLogsReporting;
	details?: IOperationLogsDetails;
}

export interface ICNRForDateRangeParams {
	vesselId: string;
	start: string;
	end: string;
	// Temproary
	limit?: string;
	skip?: string;
}

export interface ICalendarDot {
	cnrDetails: { id: string; intlDateLineRecord: boolean }[];
}

export interface IVDMDashboardLoadParams {
	cnrId?: string;
	vesselId: string;
}

export interface IVDMPICSaveParams {
	vesselId: string;
	departments: IVDMPICContent["departments"]
}

// Dashboard content types

export interface IVDMDashboardContent {
	selectedDate: string;
	intlDateLineRecord: boolean;
	vesselName: string;
	vesselImo: string;
	vesselFuels: IFuelItem[];
	updatedAt: string;
	currentlyAt: ICurrentlyAt;
	navigation: INavigation;
	operationalStatus: IOperationalStatus;
	portCalls: IPortCall[];
	bunkerRobs: IBunkerRob[];
	bunkerTankRobs: any;
	bunkerConsumptions: IBunkerConsumptions;
	stopagges: IStoppage[];
	weatherData: IWeatherData[];
	stopaggesSummary: IStoppageSummary;
	cargo?: ICargoInfo;
	lastUpdatedAt: string;
}
interface ICurrentlyAt {
	currentPosition: {
		portName: string;
		coordinates: {
			latitude: string;
			longitude: string;
		};
		status: string;
	};
	timezone: string;
	fuelMode: string[];
	state: string;
}

interface INavigation {
	heading: string;
	fwdDraft: string;
	aftDraft: string;
	sog: number;
	stw: string;
}

interface IOperationalStatus {
	hoursAtSea: number;
	hoursAtPort: number;
	hoursAtAnchor: number;
	hoursAtStoppage: number;
	totalLengthOfDay: number;
}

interface IStoppageSummary {
	plannedHours: number;
	unplannedHours: number;
	otherHours: number;
	totalHours: number;
	count: number;
}

interface IFuelItem {
	value: string;
	label: string;
}

interface IBunkerRob {
	label: string;
	value: string;
	rob: number;
	sourceReportType: string;
	sourceReportId: number;
	sourceCnrId: string;
	sourceSelectedDate: string;
}

interface IBunkerConsumptionByEquipmentSource {
	sourceReportType: string;
	sourceReportId: number;
	sourceCnrId: string;
	sourceSelectedDate: string;
}

interface IBunkerConsumptionFuelType {
	label: string;
	value: string;
	totalConsumption: number;
	consumptionByEquipment: {
		mainEngine: number;
		auxiliaryEngine: number;
		boiler: number;
		igg: number;
		others: number;
	};
	sourceByEquipment: {
		mainEngine: IBunkerConsumptionByEquipmentSource | null;
		auxiliaryEngine: IBunkerConsumptionByEquipmentSource | null;
		boiler: IBunkerConsumptionByEquipmentSource | null;
		igg: IBunkerConsumptionByEquipmentSource | null;
		others: IBunkerConsumptionByEquipmentSource | null;
	};
}

interface IBunkerConsumptionEquipmentType {
	equipmentType: string;
	fuelType: string;
	consumption: number;
	sources: {
		fuelType: string;
		sourceReportType: string;
		sourceReportId: number;
		sourceCnrId: string;
		sourceSelectedDate: string;
	}[];
}

export interface IBunkerConsumptions {
	byFuelType: IBunkerConsumptionFuelType[];
	byEquipmentType: IBunkerConsumptionEquipmentType[];
}

interface IPortCall {
	reportId: number;
	reportType: string;
	portName: string;
	date: string;
	eta: string;
	etb: string | null;
	etd: string | null;
	activityType: string[];
	selectedDate: string;
}

interface IStoppage {
	report_type: string;
	report_id: number | null;
	sourceCnrId: string;
	sourceSelectedDate: string;
	startDateTime: string;
	endDateTime: string;
	delayDuration: string;
	delayMiles: string;
	delayType: string;
	reason: string;
	remarks: string;
	parsedDelayDuration: {
		days: number;
		hours: number;
		minutes: number;
		totalMinutes: number;
		totalHours: number;
	};
	delayDurationHours: number;
	delayTypeKey: string;
}

interface IWeatherHurricaneInfo {
	name: string;
	value: string;
	distance: string;
}

interface IWeatherWind {
	direction: string;
	speed: string;
}

interface IWeatherSeaWave {
	direction: string;
	height: string;
}

interface IWeatherSwell {
	direction: string;
	height: string;
}

interface IWeatherData {
	dateTimeUtc: string;
	typeOfReport: string;
	firstLowPressureTrsHurricane: IWeatherHurricaneInfo;
	secondLowPressureTrsHurricane: IWeatherHurricaneInfo;
	wind: IWeatherWind;
	seaWave: IWeatherSeaWave;
	swell: IWeatherSwell;
	checkBvsSnapshotDangerousPhenomenon: string;
	bvsScreenshotCapturedAndShared: string;
	sourceCnrId: string;
	sourceSelectedDate: string;
	sourceReportId: number;
}

export interface IDateTimeInfo {
  date: string;
  time: string;
  timezone: string;
}

// Used by Tanker, Gas, and Bulk
export interface ICargoItem {
  cargoType: string;
  quantityLoaded: number;
  quantityDischarged: number;
  density: string | null;
  temperature: string | null;
  commencementDate: string;
  commencementDateZd: string;
  completionDate: string;
  completionDateZd: string;
}

export interface IContainerStats {
  size: string;
  units: number;
  imdg: number;
  reefers: number;
  totalWeight: number;
}

export interface IContainerDetails {
  reportCount: number;
  elapsedHours: number;
  sts: "Yes" | "No";
  outsidePortLimits: "Yes" | "No";
  remarks: string | null;
  allFast: IDateTimeInfo;
  castOff: IDateTimeInfo;
  loadedContainers: IContainerStats[];
  dischargedContainers: IContainerStats[];
  summary: {
    totalLoadedContainerUnits: number;
    totalDischargedContainerUnits: number;
    totalLoadedContainerWeight: number;
    totalDischargedContainerWeight: number;
    breakBulkLoaded: number;
    breakBulkDischarged: number;
  };
}

// Tanker and Gas are having same structure. For now keeping it same
export interface ITankerGasDetails {
  reportCount: number;
  elapsedHours: number;
  sts: "Yes" | "No";
  outsidePortLimits: "Yes" | "No";
  remarks: string | null;
  allFast: IDateTimeInfo;
  castOff: IDateTimeInfo;
  cargoes: ICargoItem[];
  summary: {
    totalCargoLoaded: number;
    totalCargoDischarged: number;
  };
}

export interface IPCTCVehicle {
  type: string;
  noOfVehiclesLoaded: number;
  noOfVehiclesDischarged: number;
  loadedVehiclesWeight: number;
  dischargedVehiclesWeight: number;
}

export interface IPCTCDetails {
  reportCount: number;
  elapsedHours: number;
  sts: "Yes" | "No";
  outsidePortLimits: "Yes" | "No";
  remarks: string | null;
  allFast: IDateTimeInfo;
  castOff: IDateTimeInfo;
  vehicles: IPCTCVehicle[];
  summary: {
    totalVehiclesLoaded: number;
    totalVehiclesDischarged: number;
    totalLoadedVehicleWeight: number;
    totalDischargedVehicleWeight: number;
  };
}

export interface IBulkDetails {
  reportCount: number;
  elapsedHours: number;
  sts: "Yes" | "No";
  outsidePortLimits: "Yes" | "No";
  remarks: string | null;
  allFast: IDateTimeInfo;
  castOff: IDateTimeInfo;
  cargoes: ICargoItem[];
  summary: {
    totalCargoLoaded: number;
    totalCargoDischarged: number;
  };
}

export type ICargoDetails = 
  | ({ type: "container" } & IContainerDetails)
  | ({ type: "tanker" } & ITankerGasDetails)
  | ({ type: "gas" } & ITankerGasDetails)
  | ({ type: "pctc" } & IPCTCDetails)
  | ({ type: "bulk" } & IBulkDetails);

export interface ICargoInfo {
  type: "container" | "tanker" | "gas" | "pctc" | "bulk";
  details: ICargoDetails;
}

export interface IVDMPICPerson {
  id: string;
  name: string;
  email: string;
  phone_number: string;
  profile_picture: string;
}

export interface IVDMPICDepartment {
  manager: IVDMPICPerson | {};
  superintendent: IVDMPICPerson | {};
  executive: IVDMPICPerson | {};
}

export interface IVDMPICContent {
  _id: string;
  modelName: string;
  vesselId: string;
  tenantId: string;
  departments: {
    technical: IVDMPICDepartment;
    operations_commercial: IVDMPICDepartment;
    marine_hr: IVDMPICDepartment;
    sqv_inspections: IVDMPICDepartment;
  };
}

export type TDepartmentID =
	| "technical"
	| "operations_commercial"
	| "marine_hr"
	| "sqv_inspections";

export type TAssignView = "assign" | "view";

export type TDepartmentWiseAssignment = IVDMPICContent["departments"];

export interface IGetCNRDateRangeParams {
	date?: Date;
	loadCNRDateRange: (params: ICNRForDateRangeParams) => void;
	vesselId: string;
}